import { render } from "./Botones_flotantes.vue?vue&type=template&id=cc9d9846&scoped=true"
import script from "./Botones_flotantes.vue?vue&type=script&lang=js"
export * from "./Botones_flotantes.vue?vue&type=script&lang=js"

import "./Botones_flotantes.vue?vue&type=style&index=0&id=cc9d9846&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9d9846"]])

export default __exports__